import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../redux/reduxActions';
import { UserInfo, GetMenuItemRow, MenuItemModel } from '../models/models';
import { PageViewTypeEnum } from '../models/enums';
import { Popup, Offset } from '@progress/kendo-react-popup';
import { Menu, MenuSelectEvent } from '@progress/kendo-react-layout';


import './Home.css';
import { Button } from '@progress/kendo-react-buttons';

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

type HomeProps = PropsFromRedux & {
    onSelectAction?: (e: GetMenuItemRow) => void;
}


interface HomeState {
    loading: boolean;
    actionItems: GetMenuItemRow[];
    hpDivStyle: React.CSSProperties;
    // popupOpen: boolean;
    homeMenuShow?: boolean;
    homeMenuOffset?: Offset;
    homeMenuItems?: MenuItemModel[];

}

class Home extends React.Component<HomeProps, HomeState> {
    constructor(props: HomeProps) {
        super(props);




        this.state = {
            loading: false,
            actionItems: [],
            hpDivStyle: {},
            // popupOpen: false,
        }
    }

    componentDidMount() {

        //Treelist needs height set
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions);


        if (this.props.pageInf.pageViewMode !== PageViewTypeEnum.Browser) {
            this.fetchActions();
        }
    }

    componentDidUpdate(prevProps: HomeProps) {
    }

    componentWillUnmount() {
    }

    updateDimensions = () => {
        let body = document.body;
        if (body) {
            let hs: React.CSSProperties = { ...this.state.hpDivStyle };
            hs.height = body.clientHeight - 80;
            hs.width = body.clientWidth
            this.setState({
                hpDivStyle: hs,
            });
        }
    }


    fetchActions = () => {
        this.setState({ loading: true, actionItems: [] });

        let url = this.props.userInf.currProject.apiUrl + '/api/ui/GetMenuItemsForUser';

        fetch(url, { method: 'GET', headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.props.userInf.token } })
            .then(resp => resp.json())
            .then(res => {
                switch (res.callStatus) {
                    case "OK":
                        //Need to remove "Home" action from list
                        let tmpRes: GetMenuItemRow[] = res.results;

                        //this.setState({ actionItems: tmpRes.filter(x => x.securityActionTypeId !== MenuItemTypeEnum.Home), loading: false });
     
                        this.setState({ actionItems: tmpRes.filter(x => (this.props.pageInf.pageViewMode === PageViewTypeEnum.Browser && x.browserEnable === true) ||
                            (this.props.pageInf.pageViewMode === PageViewTypeEnum.Mobile && x.mobileEnable === true) ||
                            (this.props.pageInf.pageViewMode === PageViewTypeEnum.Tablet && x.tabletEnable === true))
                        , loading: false });
    
                        break;
                    case "UNAUTH":
                        let uInf: UserInfo = { ...this.props.userInf, isAuthorised: false };
                        this.props.updateUserInfo(uInf);
                        break;

                    default:
                        alert('Error fetching actions - ' + res.callStatusMessage);
                }
            })
            .catch(err => {
                alert('Error fetching actions - ' + err.toString());
            });
    }


    selectAction = (e: GetMenuItemRow) => {
        if (this.props.onSelectAction)
            this.props.onSelectAction(e);
    }


    contextMenuClick = (e: MenuSelectEvent) => {
        let dataItm = e.item as MenuItemModel;

        let itmRow = dataItm.data as GetMenuItemRow;

        if (itmRow && this.props.onSelectAction)
            this.props.onSelectAction(itmRow);
    }


    renderURL = () => {
        return (<iframe src={this.props.userInf.currProject.homePageUrl} className='homePageIframe' title='HomePage' />);
    }

    renderActions = () => {
        return (<div id="homePageDiv" style={this.state.hpDivStyle}>
            <table id="homePageTbl" >
                <tbody>
                    {
                        this.renderActionItems(this.state.actionItems)
                    }
                </tbody>
            </table>
            {/* Popup for action item submenus (controlled) */}
            <Popup id="homeActionPopup" offset={this.state.homeMenuOffset ? this.state.homeMenuOffset : { left: 0, top: 0 }} show={this.state.homeMenuShow ? true : false} onClose={() => this.setState({ homeMenuShow: false })}>
                <div tabIndex={-1}>
                    {this.state.homeMenuItems && <Menu items={this.state.homeMenuItems} openOnClick={true} vertical={true} onSelect={(m) => { this.contextMenuClick(m); this.setState({ homeMenuShow: false }); }} />}
                </div>
            </Popup>
        </div>
        );

    }

    renderActionItems = (itms: GetMenuItemRow[]) => {
        // Render buttons in rows of two columns. Each item cell returns a <td> element,
        // so just group items in pairs and emit a <tr> with two <td>s (or a filler <td>).
        const rows: JSX.Element[] = [];
        for (let i = 0; i < itms.length; i += 2) {
            const first = itms[i];
            const second = itms[i + 1];
            rows.push(
                <tr key={"actionRow_" + i}>
                    {this.renderActionItemCell(first, false)}
                    {second ? this.renderActionItemCell(second, true) : <td>&nbsp;</td>}
                </tr>
            );
        }
        return rows;
    }

    openHomeContextMenu = (e: React.MouseEvent, menuItems: MenuItemModel[], isRightColumn: boolean) => {
        // compute offset so menu fits on screen; if right column, position to open left
        const target = e.currentTarget as HTMLElement;
        const rect = target.getBoundingClientRect();
        const estimatedMenuWidth = 220; // reasonable default; popup will auto-size but this helps anchor
        let left = rect.left;
        // If right column, anchor so menu appears to the left of the button
        if (isRightColumn) {
            left = Math.max(0, rect.right - estimatedMenuWidth);
        } else {
            // Prefer opening to the right, but ensure it doesn't overflow
            if (rect.left + estimatedMenuWidth > window.innerWidth) {
                left = Math.max(0, window.innerWidth - estimatedMenuWidth - 8);
            }
        }
        const top = rect.bottom;
        this.setState({ homeMenuShow: true, homeMenuOffset: { left: left, top: top }, homeMenuItems: menuItems });
        e.stopPropagation();
    }

    private lastColorSelect = 0;
    renderActionItemCell = (itm: GetMenuItemRow, isRightColumn: boolean = false) => {
        //let btnStyle: React.CSSProperties = {};


        if (itm.securityActionTypeId !== 1) {
            return (<td><Button  onClick={() => { this.selectAction(itm)}}  >
                <div className='buttonLogo'>{this.renderIconCode(itm)}</div>
                <span>{itm.description}</span>
            </Button></td>);
        } else {

            // Place the submenu caret on the left when the button is in the right column
            // so the Menu's anchor is on the left side and the popup can open to the left.
            let cssStyle: string = isRightColumn ? "subMenuBtnDivLeft" : "subMenuBtnDivRight";

            let itemMenuItms: MenuItemModel[] = [];
            let cxtMenu: MenuItemModel = {
                items: [], linkRender: () => {
                    // Render a button that opens our controlled Popup menu so we can position it
                    // to the left for right-column items.
                    return <Button onClick={(e: React.MouseEvent) => { this.openHomeContextMenu(e, cxtMenu.items, isRightColumn); }}>
                        <div className='buttonLogo'>{this.renderIconCode(itm)}</div>
                        <span>{itm.description}</span>
                        <div className= {cssStyle}>
                            <span className='k-icon k-font-icon k-i-expand' />
                        </div>    </Button>
                }
            };
            itemMenuItms.push(cxtMenu);
            itm.items.forEach(x => {
                cxtMenu.items.push({ text: x.description, action: 'openAction', data: x, cssClass: 'homeMenuItm', disabled: false, items: [] });

            });

            // We no longer render the Menu inline (it will be displayed inside the Popup).
            // Render the link/button cell (the Menu's linkRender produces the Button) by returning a <td>
            return (<td>{cxtMenu.linkRender && cxtMenu.linkRender()}</td>);

        }
    }

    renderIconCode = (itm: GetMenuItemRow) => {
        if (itm) {
            if (itm.iconImageStr)
                return (<img src={'data:image/jpeg;base64,' + itm.iconImageStr} alt='' />);
            else if (itm.iconCode)
                return <span className={'k-icon'} dangerouslySetInnerHTML={{ __html: itm.iconCode }} />
        }
        return null;
    }


    render() {
        if (this.state.loading) {
            return (<div id="homePageDiv">
                <span className='k-icon k-font-icon k-i-loading' />
            </div>);
        } else {
            if (this.props.pageInf.pageViewMode !== PageViewTypeEnum.Browser || this.props.userInf.currProject.isUAT) {
                return (this.renderActions());
            } else {
                return (this.renderURL());
            }
        }
    }
}

export default connector(Home);
